import {ModifiUiApp} from '@modifi/ui'
import styled from 'styled-components'

export const StyledModifiUiApp = styled(ModifiUiApp)`
  min-height: 100vh;
`
